import { render, staticRenderFns } from "./expectGoalScatter.vue?vue&type=template&id=3d4908a7&scoped=true"
import script from "./expectGoalScatter.vue?vue&type=script&lang=js"
export * from "./expectGoalScatter.vue?vue&type=script&lang=js"
import style0 from "./expectGoalScatter.vue?vue&type=style&index=0&id=3d4908a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4908a7",
  null
  
)

export default component.exports